import { UnidadeUFC } from "model/ufc/UnidadeUFC";
import { RootState } from "store/store"
import { EstadoRequisicao } from "store/types";
import { No } from "view/component/CascaderField/CascaderField";


export class UnidadesUFCSelector {
  static readonly estado = (it: RootState) => it.unidadesUFC.estado;
  static readonly isCarregando = (it: RootState) => it.unidadesUFC.estado === EstadoRequisicao.CARREGANDO;
  static readonly erros = (it: RootState) => it.unidadesUFC.erros;
  
  static readonly unidade = (idUnidade: number) => (it: RootState): UnidadeUFC|undefined => it.unidadesUFC.cache[idUnidade];

  static readonly cascade = () => (it: RootState): No[]|undefined => {
    if (UnidadesUFCSelector.estado(it) === EstadoRequisicao.BEM_SUCEDIDO
     && it.unidadesUFC.estruturaOrganizacional !== undefined) {
      return construirNode(it.unidadesUFC.estruturaOrganizacional)?.filhos;
      
    } else {
      return undefined;
    }
  }
}


function construirNode(unidade: UnidadeUFC): No {
  return {
    id: unidade.id,
    nome: `${unidade.nome} (${unidade.sigla})`,
    filhos: unidade.unidades?.map(it => construirNode(it))
  }
}